import { render, staticRenderFns } from "./OptionsLicence.vue?vue&type=template&id=3c203e7c&"
import script from "./OptionsLicence.vue?vue&type=script&lang=js&"
export * from "./OptionsLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports